// extracted by mini-css-extract-plugin
export default {"background":"InfoModal_background__Wz6K5","modal":"InfoModal_modal__O0MG-","viddo_modal":"InfoModal_viddo_modal__VTj5R","btn_main":"InfoModal_btn_main__B7E+l"};